import { create } from "zustand";
import { HookTransaction } from "../api/types";
import { HOOKS_PAGE_LIMIT } from "../hooks/useGetHookTransactions";

type Pagination = {
  limit: number;
  offset: number;
  hasNext: boolean;
};

interface HookTransactionsState {
  transactions: HookTransaction[];
  pagination: Pagination;
  isLoading: boolean;
  loadingNextPage: boolean;
  initialFetchDone: boolean;
  error: string | null;
  // Internal methods
  _setTransactions: (
    transactions: HookTransaction[],
    pagination: Pagination
  ) => void;
  _appendTransactions: (
    transactions: HookTransaction[],
    pagination: Pagination
  ) => void;
  _setLoading: (loading: boolean) => void;
  _setLoadingNextPage: (loading: boolean) => void;
  _setInitialFetchDone: (done: boolean) => void;
  _setError: (error: string | null) => void;
  _reset: () => void;
}

export const useHookTransactionsStore = create<HookTransactionsState>(
  (set) => ({
    transactions: [],
    pagination: {
      limit: HOOKS_PAGE_LIMIT,
      offset: 0,
      hasNext: false,
    },
    isLoading: false,
    loadingNextPage: false,
    initialFetchDone: false,
    error: null,

    _setTransactions: (transactions, pagination) =>
      set({ transactions, pagination }),

    _appendTransactions: (newTransactions, pagination) =>
      set((state) => ({
        transactions: [...state.transactions, ...newTransactions],
        pagination,
      })),

    _setLoading: (loading) => set({ isLoading: loading }),
    _setLoadingNextPage: (loading) => set({ loadingNextPage: loading }),
    _setInitialFetchDone: (done) => set({ initialFetchDone: done }),
    _setError: (error) => set({ error }),
    _reset: () =>
      set({
        transactions: [],
        pagination: {
          limit: HOOKS_PAGE_LIMIT,
          offset: 0,
          hasNext: false,
        },
        isLoading: false,
        loadingNextPage: false,
        initialFetchDone: false,
        error: null,
      }),
  })
);
